import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from '../../api/api.service';
import { BUILDING_TYPE_ENDPOINTS } from '../../api/endpoints/building-type.endpoints';

@Injectable({
  providedIn: 'root',
})
export class BuildingTypeService {
  private buildingType = new BehaviorSubject(null);
  currentBuildingType = this.buildingType.asObservable();
  private api = inject(ApiService);

  getBuildingTypes(): Observable<any> {
    return this.api.get(BUILDING_TYPE_ENDPOINTS.V1.BUILDING_TYPES).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.handleError),
    );
  }

  getBuildingStatus(): Observable<any> {
    return this.api.get(BUILDING_TYPE_ENDPOINTS.V1.BUILDING_STATUS).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.handleError),
    );
  }

  getBuildingType(): Observable<any> {
    return this.api.get(BUILDING_TYPE_ENDPOINTS.V1.BUILDING_TYPE).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.handleError),
    );
  }

  changeBuildingType(buildingType: {}) {
    this.buildingType.next(buildingType);
  }

  handleError(error) {
    let errorMessage;
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
